import React, { useEffect, useState } from "react";

import "../css/dashboard.css";
import "../css/setting.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import des styles pour Quill
import { Button } from "@mui/material";

export default function MovingToIncomingNotifications() {

  const [templateContent, setTemplateContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);


  console.log("Email template: ", templateContent);

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        console.log("Fetching template...");
        const templateRef = doc(db, "emailTemplates", "incomingClient");
        const templateDoc = await getDoc(templateRef);
        if (templateDoc.exists()) {
          setTemplateContent(templateDoc.data().content);
        } else {
          const defaultContent = "<p>Your default email template here.</p>";
          await setDoc(templateRef, { content: defaultContent });
          setTemplateContent(defaultContent);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
        alert("An error occurred while fetching the template.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplate();
  }, []);


  // Mettre à jour la prévisualisation chaque fois que le template ou les variables changent

  const handleSave = async () => {
    try {
      console.log("Saving template...");
      const templateRef = doc(db, "emailTemplates", "incomingClient");
      await updateDoc(templateRef, {
        content: templateContent,
      });
      alert("Template updated successfully");
    } catch (error) {
      console.error("Error saving template:", error);
      alert("An error occurred while saving the template.");
    }
  };// useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics("Roles", "pageLoad", currentUser.email, "read", "bodhi");
  //   }
  // }, [currentUser.email]);






  if (isLoading) {
    return <div>Loading template...</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2>Edit Incoming Client Email Template</h2>
      <div>
        <p>You can use the following variables in your template:</p>
        <ul>
          <li>
            <code>{"{{ firstName }}"}</code>
          </li>
          <li>
            <code>{"{{ lastName }}"}</code>
          </li>
          <li>
            <code>{"{{ contactInfo }}"}</code>
          </li>
          <li>
            <code>{"{{ assignedTherapist }}"}</code>
          </li>
          <li>
            <code>{"{{ assessmentDetails }}"}</code>
          </li>
          <li>
            <code>{"{{ clientId }}"}</code>
          </li>
        </ul>
      </div>
      {/* <TextareaAutosize
        value={templateContent}
        onChange={(e) => setTemplateContent(e.target.value)}
        minRows={15}
        style={{ width: "100%", fontFamily: "monospace", fontSize: "14px" }}
      /> */}

      <ReactQuill
        value={templateContent}
        onChange={setTemplateContent}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            ["link", "blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        }}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "link",
          "blockquote",
          "code-block",
          "list",
          "bullet",
        ]}
        style={{ height: "200px", marginBottom: "40px" }}
      />
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        style={{ marginTop: "10px" }}
      >
        Save Template
      </Button>
    </div>
  );
}
